"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HEADERS = void 0;

var _gerenciatdUtils = require("@bit/gerenciatd.utils.log-utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// usefull if we desire DEFAULT HEADERS
var HEADERS = {
  timeout: 50000
};
exports.HEADERS = HEADERS;

var Request =
/** Realiza una petición sondada o no.
* @param {String} method tipo de peticion: POST, GET, PUT
* @param {String} endpoint url del servicio al que se llama
* @param {Object} data conjunto de datos que se envían al servicio
* @param {Function} onError función adicional que se ejecuta dado un error
* @param {Function} onFetching función adicional que se ejecuta cuando se esta esperando respuesta
* @param {Function} onSuccess función adicional que se ejecuta cuando,
*  se obtiene respuesta del servicio
* @param {Object} headers cabeceras a utilizar en la petición.
* @param {Sonda} sonda si se recibe, el servicio se auto-sondará
* al pasar por los distintos eventos.
* @param {Boolean} dataStringify cuando es true, se transforma la información a string
*  antes de enviarse al servicio
*/
function Request(props) {
  var _this = this;

  _classCallCheck(this, Request);

  this.method = props.method || 'GET';
  this.endpoint = props.endpoint;
  this.data = props.data || null;
  this.onError = props.onError || null;
  this.onSuccess = props.onSuccess || null;
  this.onFetching = props.onFetching || null;
  this.sonda = props.sonda || null;
  this.allowRedirection = props.allowRedirection || null;
  this.headers = _objectSpread({}, HEADERS, {}, props.headers);
  var finalDataStringify = true;

  if (props.dataStringify === false) {
    finalDataStringify = false;
  }

  this.dataStringify = finalDataStringify;
  /* CHECKINGS */

  if (!this.endpoint) {
    (0, _gerenciatdUtils.errorLog)('[makeRequest]: endpoint prop can not be undefined');
    return null;
  }
  /* AUXILIAR FUNCTIONS clean for GET */


  this.cleanResponse = function (response) {
    var finalResponse = response; // Para casos en que devuelve un html o un string que no es un json

    if (typeof response === 'string' && finalResponse) {
      finalResponse = finalResponse.trim();

      try {
        finalResponse = JSON.parse(finalResponse);
      } catch (err) {
        finalResponse = response;
      }
    }

    return finalResponse;
  };

  this.errorHandler = function () {
    var currentXhr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      status: 500,
      statusText: 'Generic Error'
    };
    var onErrorObj = currentXhr;

    if (_this.onError && currentXhr) {
      var onErrorAux = _this.onError(currentXhr);

      if (onErrorAux) {
        onErrorObj = onErrorAux;
      }
    }

    return onErrorObj;
  };

  this.setRequestHeaders = function (headers, xhr) {
    var headerKeys = Object.keys(headers);
    headerKeys.forEach(function (headerKey) {
      var value = headers[headerKey];

      if (headerKey === 'withCredentials') {
        xhr.withCredentials = value;
      } else if (headerKey === 'timeout') {
        xhr.timeout = value;
      } else {
        xhr.setRequestHeader("".concat(headerKey), value);
      }
    });
  }; // doing onFetchings operations


  this.executeOnFetching = function () {
    // custom onFetching
    if (_this.onFetching) {
      _this.onFetching();
    } // use sonda object


    if (_this.sonda) {
      _this.sonda.startWS();
    }
  }; // doing onSuccess things


  this.executeOnSuccess = function (response) {
    var onSuccessObj = null; // executing custom onSuccess

    if (_this.onSuccess) {
      onSuccessObj = _this.onSuccess(response);
    } // tryng using sonda


    if (_this.sonda) {
      _this.sonda.endWS('ok');
    }

    var res = onSuccessObj || response;
    return res;
  }; // ONTIMEOUT


  this.executeOnTimeout = function (xhr, headers, reject) {
    // ONTIMEOUT
    xhr.ontimeout = function () {
      var statusText = "Timeout Error".concat(headers && headers.timeout ? ": ".concat(headers.timeout, "ms") : '');

      var data = _this.errorHandler({
        status: 500,
        statusText: statusText
      }); // tryng using sonda


      if (_this.sonda) {
        _this.sonda.endWS('error-timeout', data);
      }

      reject(data);
    };
  }; // ONERROR


  this.executeOnError = function (xhr, reject) {
    xhr.onerror = function () {
      var statusText = 'Network Error';

      var data = _this.errorHandler({
        status: 500,
        statusText: statusText
      }); // tryng using sonda


      if (_this.sonda) {
        _this.sonda.endWS('error', data);
      }

      reject(data);
    };
  }; // onLoad xhr


  this.onLoadXhr = function (xhr, resolve, reject) {
    xhr.onload = function () {
      // Analizamos la reponse
      var myResponse = _this.cleanResponse(xhr.response);

      if (xhr.status >= 200 && xhr.status < 300) {
        var res = _this.executeOnSuccess(myResponse);

        resolve(res);
      } else if (xhr.status <= 300 && xhr.status < 400) {
        // FIRST OF ALL WE need to detect redirection kind
        var redirectionData = {
          status: xhr.status,
          response: myResponse // to: 'https://www.movistar.com',

        };

        _this.executeOnSuccess(redirectionData);

        resolve(redirectionData);
      } else {
        var data = _this.errorHandler({
          status: xhr.status,
          statusText: xhr.statusText
        });

        if (_this.sonda) {
          _this.sonda.endWS('error', data);
        }

        reject(data);
      }
    };
  }; // sending info


  this.sendXhrInfo = function (xhr) {
    // SEND INFO
    if (_this.data) {
      if (_this.dataStringify) {
        xhr.send(JSON.stringify(_this.data));
      } else {
        xhr.send(_this.data);
      }
    } else {
      xhr.send();
    }
  };
  /* MAIN */


  this.makeRequest = function () {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(_this.method, _this.endpoint, true); // apply headers to this xhr

      _this.setRequestHeaders(_this.headers, xhr);

      _this.executeOnFetching(); // lets see many events
      // ontimeout


      _this.executeOnTimeout(xhr, _this.headers, reject); // onerror


      _this.executeOnError(xhr, reject); //  onload


      _this.onLoadXhr(xhr, resolve, reject); // sending info


      _this.sendXhrInfo(xhr);
    })["catch"](function (err) {
      if (_this.sonda) {
        var statusText = "[Utils.Request]: ".concat(err);

        var data = _this.errorHandler({
          status: 500,
          statusText: statusText
        });

        _this.sonda.endWS('js-error', data);

        (0, _gerenciatdUtils.errorLog)(statusText, 'error-request');
      }
    });
  };
};

var _default = Request;
exports["default"] = _default;

//# sourceMappingURL=index.js.map